import {
  AddCouponByCodeDto,
  AddCouponByCodeResponse,
  UserCoupon,
  UserCouponStatus,
} from '@monorepo/types';
import { BaseResponse } from '../core/base-entity-service';
import CrudService from '../core/crud-service';

export default class CouponService extends CrudService {
  static override route = 'coupon';

  async getUserCoupons() {
    try {
      const response = await this.httpService.get<BaseResponse<UserCoupon[]>>(
        this.path,
      );
      return response.data || [];
    } catch (e) {
      console.error('Error fetching user coupons:', e);
      throw new Error('Failed getting coupons');
    }
  }

  async createUserCoupon(params: { org: string; name: string }) {
    try {
      const response = await this.httpService.post<
        { org: string; name: string },
        { data: { coupon: UserCoupon | null; status: UserCouponStatus } }
      >(this.path, params);
      return response.data || null;
    } catch (e) {
      console.error('Error creating user coupon:', e);
      throw new Error('Failed getting coupons');
    }
  }

  async getCouponMetrics() {
    try {
      const response = await this.httpService.get<
        BaseResponse<{
          activeCount: number;
          usedCount: number;
          totalSaved: number;
        }>
      >(`${this.path}/coupons-metrics`);
      return response.data || { activeCount: 0, usedCount: 0, totalSaved: 0 };
    } catch (e) {
      console.error('Error fetching coupon metrics:', e);
      throw new Error('Failed getting coupon metrics');
    }
  }

  async addCouponByCode(payload: AddCouponByCodeDto) {
    try {
      const response = await this.httpService.post<
        AddCouponByCodeDto,
        { data: AddCouponByCodeResponse }
      >(`${this.path}/code`, payload);
      return response.data || null;
    } catch (e) {
      console.error('Error adding coupon by code:', e);
      throw e;
    }
  }
}
